import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useUpdateTreatmentPlan = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({
      treatmentPlan,
      id,
    }: {
      treatmentPlan: FormData;
      id: string;
    }) => {
      return api.patch(`treatments/${id}`, treatmentPlan, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      // console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "update-treatment-plan-success",
      });
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.treatmentPlanWithFilters(
          variables.treatmentPlan.get("patient_id") as string
        ),
      });
    },

    onError: (res, variables) => {
      console.error("[From Update Treatment Plan]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.treatmentPlanWithFilters(
          variables.treatmentPlan.get("patient_id") as string
        ),
      });

      handleErrors(res, "mutation");
    },
  });
};
